import { types } from 'mobx-state-tree';
import { Model, model } from 'mst-collection';

import { CourseModel } from '@models/Courses/CourseModel';
import { TutorialModel } from '@models/Tutorials/TutorialModel';

export class CourseItem extends Model({
  schema: types.literal('course'),
  id: types.reference(CourseModel),
}) {
  get data() {
    return this.id;
  }
}
const CourseItemModel = model(CourseItem);

export class TutorialItem extends Model({
  schema: types.literal('tutorial'),
  id: types.reference(TutorialModel),
}) {
  get data() {
    return this.id;
  }
}
const TutorialItemModel = model(TutorialItem);

export type TutorialCourseItemType = TutorialItem | CourseItem;

export const TutorialCourseUnionType = types.union(
  TutorialItemModel,
  CourseItemModel,
);
